/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FormAnswer interface.
 */
export function instanceOfFormAnswer(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
export function FormAnswerFromJSON(json) {
    return FormAnswerFromJSONTyped(json, false);
}
export function FormAnswerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'text': json['text'] == null ? undefined : json['text'],
    };
}
export function FormAnswerToJSON(json) {
    return FormAnswerToJSONTyped(json, false);
}
export function FormAnswerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'text': value['text'],
    };
}
